import * as types from "./types";
// import database from '../config/database';

export function actionUserOpeningTimeslot(payload) {
  return {
    type: types.USER_OPENING_TIMESLOT,
    value: payload
  };
}

export function functionUserOpeningTimeslot(data) {
  return dispatch => {
    dispatch(
      actionUserOpeningTimeslot({
        data
      })
    );
  };
}
